export const FILTERS_MODULE_NAME = "Filters";
